import React from 'react';
import PropTypes from 'prop-types';

import Card from '../Card/Card';
import LinkText from '../LinkText/LinkText';
import * as Styled from './ConfirmationCard.styled';

/**
 * Displays a `Card` with message confirming that a product has been removed and an undo button.
 */
const ConfirmationCard = ({ title, onUndo, ...props }) => (
  <Card {...props}>
    <Styled.CardContent>
      <Styled.Message>
        <Styled.ProductName>{title}</Styled.ProductName> has been removed.
      </Styled.Message>
      <LinkText onClick={onUndo} underline size="Mini">
        undo
      </LinkText>
    </Styled.CardContent>
  </Card>
);

ConfirmationCard.propTypes = {
  /**
   * Product Title
   */
  title: PropTypes.string.isRequired,
  /**
   * Function to call when `undo` button is clicked.
   */
  onUndo: PropTypes.func.isRequired
};

export default ConfirmationCard;
